import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const SButton = styled.a`
    position: relative;
    align-self: baseline;
    display: block;
    ${FONTS.MediumS};
    color: ${COLORS.ButtonAccent};
    padding-right: 15px;

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 11px;
        height: 11px;
        background-color: ${COLORS.ButtonAccent};
        mask-image: url('/static/images/icons/arrow_right_red.svg');
        mask-size: contain;
        mask-position: center;
        mask-repeat: no-repeat;
    }

    &:hover {
        color: ${COLORS.Error};

        &:after {
            background-color: ${COLORS.Error};
        }
    }
`;
